import { render, staticRenderFns } from "./Major.vue?vue&type=template&id=57462c3e&scoped=true"
import script from "./Major.vue?vue&type=script&lang=js"
export * from "./Major.vue?vue&type=script&lang=js"
import style0 from "./Major.vue?vue&type=style&index=0&id=57462c3e&prod&lang=stylus&rel=stylesheet%2Fstylus"
import style1 from "./Major.vue?vue&type=style&index=1&id=57462c3e&prod&lang=stylus&scoped=true"
import style2 from "./Major.vue?vue&type=style&index=2&id=57462c3e&prod&scoped=true&media=print&lang=css"
import style3 from "./Major.vue?vue&type=style&index=3&id=57462c3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57462c3e",
  null
  
)

export default component.exports